import { SnapLayerAPIService } from './../model/api-services/snap-layer-api.service';
import { CrossStreetsComponent } from './../components/location/cross-streets/cross-streets.component';
import { PDFOutputPreviewDialogEntryComponent, PDFOutputPreviewDialogComponent } from './../components/dialogs/pdf-output-preview-dialog/pdf-output-preview-dialog.component';
import { ScaleBarComponent } from './../components/scale-bar/scale-bar.component';
import { ScaleAndLocationDialogService } from './../components/dialogs/scale-and-location-dialog/scale-and-location-dialog-service';
import { ScaleAndLocationDialogEntryComponent, ScaleAndLocationDialogComponent } from './../components/dialogs/scale-and-location-dialog/scale-and-location-dialog';

import { ArcgisService } from './../model/api-services/arcgis/arcgis.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BufferFormComponent } from '../components/buffer-form/buffer-form.component';
import { ModalLocationEntryComponent } from '../components/dialogs/modal-location-entry/modal-location-entry.component';
import { LngLatFormComponent } from '../components/location/lng-lat-form/lng-lat-form.component';
import { UtmFormComponent } from '../components/location/utm-form/utm-form.component';
import { MapComponent } from '../components/map/map.component';
import { ResultPopupComponent } from '../components/result-popup/result-popup.component';
import { UiElementsModule } from './ui-elements.module';
import { GeocodeComponent } from '../components/location/geocode/geocode.component';

import { LayersViewComponent } from '../components/layers-view/layers-view.component';
import { LayersViewV2Component } from '../components/layers-view-v2/layers-view-v2.component';

import { LayerViewComponent } from '../components/layer-view/layer-view.component';
import { SearchViewComponent } from '../components/search-view/search-view.component';
import { SearchCriteriaListComponent } from '../components/search-view/search-criteria-list/search-criteria-list.component';

import { LegendViewComponent } from '../components/legend-view/legend-view.component';
import { LayerAttributesViewComponent } from '../components/layer-attributes-view/layer-attributes-view.component';
import { LayerAttributeViewComponent } from '../components/layer-attribute-view/layer-attribute-view.component';
import { AttVocabViewComponent } from '../components/att-vocab-view/att-vocab-view.component';
import { AttConditionViewComponent } from '../components/att-condition-view/att-condition-view.component';
import { AttCastingViewComponent } from '../components/att-casting-view/att-casting-view.component';

import { ResultsViewComponent } from '../components/results-view/results-view.component';
import { ClassificationViewComponent } from '../components/classification-view/classification-view.component';
import { LayerListProviderService } from '../services/layer-list-provider.service';
import { LegendItemComponent } from '../components/legend-view/legend-item/legend-item.component';
import { LegendListProviderService } from '../services/legend-list-provider.service';
import { ModalResultStyleEntryComponent } from '../components/dialogs/modal-result-style/modal-result-style.component';
import { AttributesService } from '../model/api-services/attributes.service';
import { StorageService } from '../model/api-services/storage-services.service';
import { ResultStyleEditorComponent } from '../components/result-style-editor/result-style-editor.component';
import { ActionItemComponent } from 'src/app/components/action-group/action-item/action-item.component';
import { SelectToolsComponent } from '../components/select-tools/select-tools.component';
import { MemoryToolsComponent } from '../components/memory-tools/memory-tools.component';
import { ZoomToToolsComponent } from '../components/zoom-to-tools/zoom-to-tools.component';
import { HyperlinkColumnComponent } from '../components/results-view/custom-columns/hyperlink-column/hyperlink-column.component';
import { ActionsColumnComponent } from '../components/results-view/custom-columns/actions-column/actions-column.component';
import { SearchCriterionComponent } from '../components/search-criterion/search-criterion.component';
import { DrawPaneComponent } from '../components/draw-pane/draw-pane.component';
import { LayerSelectComponent } from '../components/layer-select/layer-select.component';
import { SnapLayerSelectComponent } from '../components/attribute-view/snap-layer-select/snap-layer-select.component';
import { ResultsPopupEditorComponent } from '../components/results-popup-editor/results-popup-editor.component';
import { AttributeViewComponent } from '../components/attribute-view/attribute-view.component';
import { PropertyValPipe } from '../model/pipes/property-val.pipe';
import { LocalPipe } from '../model/pipes/local.pipe';
import { PUCComponent } from '../components/p-u-c/p-u-c.component';
import { ResultBufferViewComponent } from '../components/result-buffert-view/result-buffer-view.component';
import { DragulaModule } from 'ng2-dragula';
import { KvPairListStringPipe } from '../model/pipes/kv-pair-list-string.pipe';
import { DigitizerComponent } from '../components/attribute-view/digitizer/digitizer.component';
import { LegendClassComponent } from '../components/legend-view/legend-item/legend-class/legend-class.component';
import { StreetInputComponent } from '../components/location/street-input/street-input.component';



@NgModule({
  declarations: [
    BufferFormComponent,
    ModalLocationEntryComponent,
    ModalResultStyleEntryComponent,
    LngLatFormComponent,
    UtmFormComponent,
    MapComponent,
    ResultPopupComponent,
    GeocodeComponent,
    StreetInputComponent,
    CrossStreetsComponent,
    LayersViewComponent,
    LayersViewV2Component,
    LayerViewComponent,
    LayerAttributesViewComponent,
    LayerAttributeViewComponent,
    AttVocabViewComponent,
    AttConditionViewComponent,
    AttCastingViewComponent,
    ResultBufferViewComponent,
    SearchViewComponent,
    SearchCriteriaListComponent,
    LegendViewComponent,
    ResultsViewComponent,
    ClassificationViewComponent,
    LegendItemComponent,
    LegendClassComponent,
    ResultStyleEditorComponent,
    ActionItemComponent,
    SelectToolsComponent,
    MemoryToolsComponent,
    ZoomToToolsComponent,
    HyperlinkColumnComponent,
    ActionsColumnComponent,
    SearchCriterionComponent,
    DrawPaneComponent,
    LayerSelectComponent,
    SnapLayerSelectComponent,
    ResultsPopupEditorComponent,
    AttributeViewComponent,
    PropertyValPipe,
    LocalPipe,
    PUCComponent,
    KvPairListStringPipe,
    DigitizerComponent,
    ScaleAndLocationDialogEntryComponent,
    ScaleAndLocationDialogComponent,
    PDFOutputPreviewDialogEntryComponent,
    PDFOutputPreviewDialogComponent,
    ScaleBarComponent
  ],
  imports: [
    CommonModule,
    UiElementsModule,
    DragulaModule,
  ],
  exports: [
    BufferFormComponent,
    ModalLocationEntryComponent,
    ModalResultStyleEntryComponent,
    LngLatFormComponent,
    UtmFormComponent,
    MapComponent,
    ResultPopupComponent,
    GeocodeComponent,
    StreetInputComponent,
    CrossStreetsComponent,
    LayersViewComponent,
    LayerViewComponent,
    LayersViewV2Component,
    LayerAttributesViewComponent,
    LayerAttributeViewComponent,
    AttVocabViewComponent,
    AttConditionViewComponent,
    AttCastingViewComponent,
    ResultBufferViewComponent,
    SearchViewComponent,
    SearchCriteriaListComponent,
    LegendViewComponent,
    ResultsViewComponent,
    ClassificationViewComponent,
    LegendItemComponent,
    LegendClassComponent,
    ResultStyleEditorComponent,
    ActionItemComponent,
    SelectToolsComponent,
    MemoryToolsComponent,
    ZoomToToolsComponent,
    HyperlinkColumnComponent,
    ActionsColumnComponent,
    SearchCriterionComponent,
    DrawPaneComponent,
    LayerSelectComponent,
    SnapLayerSelectComponent,
    ResultsPopupEditorComponent,
    AttributeViewComponent,
    PropertyValPipe,
    LocalPipe,
    PUCComponent,
    KvPairListStringPipe,
    DigitizerComponent,
    ScaleAndLocationDialogComponent,
    ScaleAndLocationDialogEntryComponent,
    PDFOutputPreviewDialogEntryComponent,
    PDFOutputPreviewDialogComponent,
    ScaleBarComponent,

  ],
  providers: [
    LayerListProviderService,
    LegendListProviderService,
    AttributesService,
    StorageService,
    ArcgisService,
    SnapLayerAPIService
  ]
})
export class MappingModule { }
